var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    className: "svg replaced-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M70.032,55.187a26.439,26.439,0,0,1-8,2,13.641,13.641,0,0,0,6-8,27.976,27.976,0,0,1-9,4,15.374,15.374,0,0,0-11-5c-7.945,0-14,6.66-14,15a12.734,12.734,0,0,0,0,3,37.954,37.954,0,0,1-29-15,13.48,13.48,0,0,0-2,7c0,5.243,2.185,10.309,6,13a11.964,11.964,0,0,1-6-2h0c0,7.357,4.477,13.592,11,15-1.168.337-1.679,0-3,0a14.808,14.808,0,0,1-3,0c1.859,6,6.726,10.857,13,11a28.085,28.085,0,0,1-18,6,19.722,19.722,0,0,1-3,0,39.019,39.019,0,0,0,22,7c26.408,0,41-23,41-43,0-.669.031-1.358,0-2A29.464,29.464,0,0,0,70.032,55.187Z",
    transform: "translate(-0.032 -48.187)",
    fill: "#03a9f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.1784c40dd1f0ee286ff09f3b90caad2b.svg";
export { ForwardRef as ReactComponent };